(function() {
    'use strict';

    angular.module('stats')
        .controller('PreviewPackageDaysModalController', PreviewPackageDaysModalController);

    PreviewPackageDaysModalController.$inject = ['lodashService', '$uibModalInstance', 'startDate', 'endDate', 'previewLoadingConst'];

    function PreviewPackageDaysModalController(lodashService, $uibModalInstance, startDate, endDate, previewLoadingConst) {
        var self = this;
        self.weekView = true;
        self.daysView = false;
        self.startDate = startDate;
        self.endDate = endDate;
        self.close = close;
        self.previewLoading = true;
        self.pagesLoaded = 0;
        self.pagesLoadingText = previewLoadingConst.pagesLoadingText;
        self.switchWeekView = switchWeekView;
        self.switchDayView = switchDayView;

        function switchWeekView() {
            self.weekView = true;
            self.daysView = false;
        }
        function switchDayView() {
            self.weekView = false;
            self.daysView = true;
        }

        function close() {
            self.startDate = null;
            self.endDate = null
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
